import React, { useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function PurchaseSection() {
  const [selected, setSelected] = useState(0);
  const plans = [{
    id: 0,
    emoji: '📘',
    title: 'SISTEMA 360',
    badge: null,
    description: 'Sistema Ciclista 360 completo (5 Tomos) + 5 Regalos incluidos. Todo lo que necesitás para rendir más y sufrir menos.',
    oldPrice: '$39.990',
    price: '$19.990',
    checkoutUrl: 'https://ciclistacheck.librosdigitales.pro/cart/45136554065999:1'
  }, {
    id: 1,
    emoji: '🏆',
    title: 'SISTEMA 360 + PROTOCOLO WORLD TOUR',
    badge: null,
    description: 'Todo lo anterior + Protocolo World Tour: la rutina de entrenamiento de los 3 primeros y mejores del mundo en el ciclismo profesional.',
    oldPrice: '$53.990',
    price: '$26.990',
    checkoutUrl: 'https://ciclistacheck.librosdigitales.pro/cart/45136557310031:1'
  }, {
    id: 2,
    emoji: '🍽️',
    title: 'SISTEMA 360 + LA COCINA DEL PELOTÓN',
    badge: null,
    description: 'Todo lo del Sistema 360 + 5 Regalos + La Cocina del Pelotón: la dieta exacta de los 3 primeros del mundo del ciclismo profesional.',
    oldPrice: '$59.990',
    price: '$26.990',
    checkoutUrl: 'https://ciclistacheck.librosdigitales.pro/cart/45136557408335:1'
  }, {
    id: 3,
    emoji: '🚀',
    title: 'FULL STACK — TODO INCLUIDO',
    badge: 'MÁS ELEGIDO',
    description: 'Sistema 360 + 5 Regalos + Protocolo World Tour + La Cocina del Pelotón. El paquete completo para el máximo rendimiento.',
    oldPrice: '$76.990',
    price: '$31.990',
    checkoutUrl: 'https://ciclistacheck.librosdigitales.pro/cart/45136557441103:1'
  }];
  return <section id="compra" className="bg-gradient-to-b from-gray-950 to-gray-900 text-white py-16 px-4" data-id="element-128">
      <div className="max-w-3xl mx-auto" data-id="element-129">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-2" data-id="element-130">
          Elegí tu <span className="text-green-400" data-id="element-131">PLAN:</span>
        </h2>
        <p className="text-gray-400 text-center mb-10" data-id="element-132">
          Todas las opciones incluyen los 5 regalos estratégicos
        </p>

        <div className="space-y-4 mb-8" data-id="element-133">
          {plans.map(plan => <div key={plan.id} onClick={() => setSelected(plan.id)} className={`relative flex items-center gap-4 p-5 rounded-xl cursor-pointer transition-all duration-300 border-2 ${selected === plan.id ? 'border-green-500 bg-gray-800/80 shadow-lg shadow-green-500/10' : 'border-gray-700 bg-gray-800/40 hover:border-gray-600'}`} data-id="element-134">
              <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-all ${selected === plan.id ? 'border-green-500 bg-green-500' : 'border-gray-500'}`} data-id="element-135">
                {selected === plan.id && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-136" />}
              </div>

              <div className="flex-1 min-w-0" data-id="element-137">
                <div className="flex items-center gap-2 flex-wrap" data-id="element-138">
                  <span className="text-lg" data-id="element-139">{plan.emoji}</span>
                  <span className="font-bold text-sm md:text-base" data-id="element-140">
                    {plan.title}
                  </span>
                </div>
                {plan.badge && <span className="inline-block mt-1 bg-green-600 text-white text-xs font-bold px-2 py-0.5 rounded" data-id="element-141">
                    ⭐ {plan.badge}
                  </span>}
                <p className="text-gray-400 text-xs md:text-sm mt-1" data-id="element-142">
                  {plan.description}
                </p>
              </div>

              <div className="text-right flex-shrink-0" data-id="element-143">
                <p className="text-gray-500 text-sm line-through" data-id="element-144">
                  {plan.oldPrice}
                </p>
                <p className={`text-2xl font-bold ${selected === plan.id ? 'text-green-400' : 'text-white'}`} data-id="element-145">
                  {plan.price}
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-146">
          <p className="text-sm text-gray-300 mb-4" data-id="element-147">
            Al hacer clic vas a ser redirigido a Mercado Pago para completar el
            pago de forma segura. Tu acceso se habilita automáticamente después
            de pagar.
          </p>
          <a href={plans[selected].checkoutUrl} className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-bold text-lg md:text-xl px-10 md:px-12 py-4 md:py-5 rounded-lg shadow-2xl hover:shadow-green-600/50 transition-all duration-300 animate-pulse w-full md:w-auto justify-center" data-id="element-148">
            ¡SÍ, QUIERO {plans[selected].title}!{' '}
            <ArrowRightIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-149" />
          </a>
          <p className="text-sm text-gray-400 mt-4" data-id="element-150">
            🔒 Pago 100% seguro y encriptado
          </p>
          <p className="text-xs text-gray-500 mt-2" data-id="element-151">
            💳 Pago único · Acceso inmediato · PDF descargable
          </p>
        </div>

        <div className="mt-10 bg-gray-800 border border-gray-700 rounded-lg p-6" data-id="element-152">
          <h3 className="font-bold text-lg mb-4" data-id="element-153">
            {plans[selected].title} INCLUYE:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm" data-id="element-154">
            <div className="flex items-center gap-2" data-id="element-155">
              <span className="text-green-500" data-id="element-156">✓</span>
              <span data-id="element-157">5 Tomos completos (+400 páginas)</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-158">
              <span className="text-green-500" data-id="element-159">✓</span>
              <span data-id="element-160">5 Regalos estratégicos</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-161">
              <span className="text-green-500" data-id="element-162">✓</span>
              <span data-id="element-163">Adaptado 100% a Argentina</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-164">
              <span className="text-green-500" data-id="element-165">✓</span>
              <span data-id="element-166">Acceso inmediato en PDF</span>
            </div>
            {(selected === 1 || selected === 3) && <div className="flex items-center gap-2" data-id="element-167">
                <span className="text-green-500" data-id="element-168">✓</span>
                <span data-id="element-169">
                  Protocolo World Tour — Rutina de los top 3 del mundo
                </span>
              </div>}
            {(selected === 2 || selected === 3) && <div className="flex items-center gap-2" data-id="element-170">
                <span className="text-green-500" data-id="element-171">✓</span>
                <span data-id="element-172">
                  La Cocina del Pelotón — Dieta de los top 3 del mundo
                </span>
              </div>}
          </div>
        </div>
      </div>
    </section>;
}